export default "__VITE_ASSET__ef03813d__"